import { useState } from 'react';
import {
    InputGroup,
    Form
} from 'react-bootstrap';
import CONSTANTS from '../constants';
import fab_aer from '../imgs/logo_AeR_botao_redondo_fundo_roxo.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function BuscaTexto(props) {
    const [q, setQ] = useState(props.q);
    if (props.menuDisabled) {
        return (
            <a id="BuscaTexto" href={CONSTANTS.HOME}>
                <img src={fab_aer} alt="Início" />
            </a>
        );
    }

    return (
        <Form
            id="BuscaTexto"
            onSubmit={(e) => {
                e.preventDefault();
                props.onChange({q: q});
            }}
        >
            <InputGroup>
                <InputGroup.Text id="basic-addon1">
                    <FontAwesomeIcon icon={"search"} />
                </InputGroup.Text>
                <Form.Control
                    placeholder="Busca por palavra"
                    aria-label="Busca por palavra"
                    aria-describedby="basic-addon1"
                    defaultValue={props.q}
                    onChange={(e) => {
                        if (e.target.value !== props.q) {
                            setQ(e.target.value);
                        }
                    }}
                />
            </InputGroup>
            <a href={CONSTANTS.HOME}>
                <img src={fab_aer} alt="Início" />
            </a>
        </Form>
    );
}
